import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { MasterService } from '../../../../services/master.service';
import { MessageService } from '../../../../services/message.service'
import { StoreService } from '../../../../services/store.service'
import * as languageLibrary from '../../../../services/language'

// external
import moment from 'moment'
import { Observable } from 'rxjs';

@Component({
    selector: 'app-contacts-detail',
    templateUrl: './contacts-detail.component.html',
    styleUrls: ['./contacts-detail.component.scss'],
    standalone: false
})
export class ContactsDetailComponent implements OnInit {

    /*
    * Variables
    */
    protected language: string = 'EN'

    protected words = languageLibrary.language
    
    protected contactId: number = 0

    protected viewAlert: boolean = false
    
    protected isIndividual: boolean = true

    protected loading: boolean = false
    
    protected contact: any;

    // Indicates whether or not the contact role is fixed for this list.
    protected fixedRole = false

    // The name of the fixed contact role or null if none.
    protected fixedRoleName = null

    // The UI route path of the fixed contact role (default: 'contacts').
    protected path = 'contacts'

    get isEmployee() { 
        if (!this.contact || !this.contact.roles || (this.contact.roles.length <= 0)) {
            return false
        }

        const roles = this.contact.roles.toLowerCase().split(',')
        if (!roles || (roles.length <= 0)) {
            return false
        }

        return roles.includes('employee')
    }

    /*
    * life cycles
    */
    constructor(private router: Router, private route: ActivatedRoute, private master: MasterService, private ms: MessageService, protected store: StoreService) {}

    ngOnInit() {
        const path = this.route.snapshot.routeConfig.path
        const pattern = new RegExp('employee', 'i')
        this.fixedRole = (path && pattern.test(path))
        if (this.fixedRole) {
            this.fixedRoleName = 'Employees'
            this.path = 'employees'
        }

        this.contactId = parseInt(this.route.snapshot.params['id'])
        if (isNaN(this.contactId) || (this.contactId <= 0)) {
            this.contactId = 0
        }

        this.getContact()
    }

    protected getContact() {
        if (!this.contactId || (this.contactId <= 0)) {
            return
        }

        this.loading = true
        this.master.get(`contacts/${this.contactId}`, res => {
            this.loading = false

            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            if (!res.data.contact) {
                return
            }

            this.contact = res.data.contact
        })
    }

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break
        }
    }

    // todo: listener to childrens
    protected listenerChildrens = (e): void => {
        if (!e || !e.message) {
            return
        }
        switch (e.message) {
            case 'changeLanguage':
                this.language = e['value']
                break;
            case 'individualValue':
                this.isIndividual = e.value
                break
            case 'setContactId':
                this.contactId = parseInt(e.value)
                break
        }
    }
}
